export const getBottomMargin = (
  isMobile: boolean,
  desktopBottomMargin: string,
  mobileBottomMargin: string
) => {
  const bottomMargin = isMobile ? mobileBottomMargin : desktopBottomMargin;
  return bottomMargin;
};
